import { findThirdPoint, g } from "../shared/common";
import { a, getDisplayedShapes } from "../shared/globalState/a";
import { addShapes, updateAndDrawShapes } from "../shared/render/shapes";
import { Point } from "../models/Point";
import { findConnectedLineEnd, findConnectedLineStart } from "./joinObserver";
import { SelectBoundary } from "../models/frames/SelectBoundary";

/**
 * Должны ли одновременно отображаться несколько марок, будь то информация или ввод данных? Наверное нет,
 * поэтому для всех марок на фигурах будет один класс, по которому они и будут выбираться
 */
const ttcname = "shape-tooltip";
const gridcname = "grid-tooltip";
const OFFSET_LEFT = window.innerWidth / 2 - 100;
const OFFSET_BOTTOM = 25;


/**
 * Функция добавления всплывающих сообщений.
 * Главным образом функция предназначается отображения информации объектов, например такой как длина линии.
 * @param {string} id - id объекта, которому принадлежит подсказка
 * @param {string} type - тип объекта - это может быть линия, прямоугольник и так далее - "line, rectangle ..."
 * @param {object} selectBoundary - область объекта. На данный момент все объекты - линии, прямоугольники и круги имеют объект "selectBoundary", который является прямоугольником из точек p1, p2, p3, p4
 */
function addTooltipInfo(id: string, selectBoundary: SelectBoundary, htmlMessage: string): string | undefined {
    if (a.pan) {
        return;
    }
    var existingTooltip = document.querySelector(`.${ttcname}`);
    if (existingTooltip) {
        clearTooltipAll();
    }
    var tooltip = document.createElement("div");
    tooltip.classList.add(ttcname);
    tooltip.classList.add(gridcname);
    tooltip.setAttribute("id", id);
    var offsetLeft = window.innerWidth /2 - 100;
    var offsetBottom = 25;
    var anchor = new Point(offsetLeft, offsetBottom);

    var anchorX = anchor.x;
    var anchorY = anchor.y;
    tooltip.style.left = anchorX + "px";
    tooltip.style.bottom = anchorY + "px";
    tooltip.innerHTML = htmlMessage;

    document.body.appendChild(tooltip);
    return tooltip.id;

}
/**
 * Функция добавления поля ввода длины для линий
 * @param {string} id - id объекта
 * @param {number} length - длина линии
 */
function addTooltipLength(id: string, selectBoundary: SelectBoundary, length: number, anchorFunction: (boundary: SelectBoundary) => Point) {

    var anchor = anchorFunction(selectBoundary);
    var offsetBottom = 25;
    var { tooltip, inputField } = createTooltipWithInput(length, id, offsetBottom);

    var existingTooltip = document.querySelector(`.${ttcname}`);
    
    if (!existingTooltip) {
        
        document.body.appendChild(tooltip);
        inputField.focus();
        inputField.select();
        inputField.addEventListener("keydown", function (e) {
            if (e.key === 'Enter') {
                /**
                 * Это очевидно, но просто напоминание - этот блок выполняется только если во время черчения нажат Enter,
                 * то есть на текущую функциональность он никак не влияет
                 */
                let virtualLineEnd: Point;
                if (a.magnetPosition) {
                    virtualLineEnd = (a.magnetPosition as Point).clone();
                }
                else {
                    virtualLineEnd = a.line.end?.clone() ?? new Point(0, 0);
                }
                let inputValue = parseFloat(inputField.value)
                let point3 = findThirdPoint(a.line.start, virtualLineEnd, inputValue*a.zlc);
                a.line.end = point3;

                let shape = a.line.getClone();

                if (a.drawingMode === 'duct' || a.drawingMode === 'pipe') { // заглушка, позже здесь появится режим - к линии будут добавляться разные объекты в зависимости от режима


                    shape.net = a.preNetInfo.getClone();
                    shape.net.setRealLenMet(shape.getLength(), a.zlc);

                    let neiStart = findConnectedLineStart(shape, getDisplayedShapes());
                    let neiEnd = findConnectedLineEnd(shape, getDisplayedShapes());

                    let angle;

                    if (!neiStart && !neiEnd) {
                    }
                    else if (neiStart) {
                        angle = shape.getAngleBetween(neiStart);
                        // shape.net.attachElbow('start', angle, 1);
                    }
                    else if (neiEnd) {
                        angle = shape.getAngleBetween(neiEnd);
                        // shape.net.attachElbow('end', angle, 1);

                    }
                }
                
                addShapes(shape);
                a.clickLineStart = null;
                a.isMouseDown = false;
                clearTooltipAll();
                updateAndDrawShapes();
            }
        });

    }
    else {
        let input = existingTooltip.firstChild as HTMLInputElement;
        input.value = String(length);
        input.focus();
        input.select();


    }




}
/**
 * Функция добавления двух марок - для ширины и длины. Используется для прямоугольников
 */
function addTooltipWidthAndHeight(id: string, width: number, height: number, anchor: Point, mouse: Point) {

    var rectWidth, rectHeight;

    var offsetBottom = 50;
    
    var { tooltip:mark1, inputField:inputField1 } = createTooltipWithInput(width, id+1, offsetBottom);
    var emark1 = document.getElementById(id + 1);
    if (!emark1) {
        document.body.appendChild(mark1);
        emark1 = document.getElementById(String(id + 1));
        mark1.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
                if (a.magnetPosition) {
                    a.end = (a.magnetPosition as Point).clone();
                    
                }
                else {
                    a.end = mouse.clone();
                }

                let inputValue1 = parseFloat(inputField1.value);
                let inputValue2 = parseFloat(inputField2.value);
                
                a.rectangle.width = inputValue1*a.zlc;
                a.rectangle.height = inputValue2*a.zlc;
    
                a.rectangle.p2 = new Point(a.rectangle.p1.x + a.rectangle.width, a.rectangle.p1.y);
                a.rectangle.p3 = new Point(a.rectangle.p1.x + a.rectangle.width, a.rectangle.p1.y + a.rectangle.height);
                a.rectangle.p4 = new Point(a.rectangle.p1.x, a.rectangle.p1.y + a.rectangle.height);
    
                a.rectangle.updateCenter();
    
                let shape = a.rectangle.getClone();
                shape.updatePoints();
    
                addShapes(shape);
    
    
                a.clickRectangleStart = null;
                a.isMouseDown = false;
                updateAndDrawShapes();
                clearTooltipAll();
    
           } 
            else if (e.altKey) {
                let inputValue1 = parseFloat(inputField1.value);
                rectWidth = inputValue1 * a.zlc;
           }
        });
    
    }
    var top = parseFloat(mark1.style.top.split('px')[0]);
    var left = parseFloat(mark1.style.left.split('px')[0]);
    var offset = mark1.clientHeight;
    var anchor2 = g(left, top+offset);
    var { tooltip: mark2, inputField: inputField2 } = createTooltipWithInput(height, String(id+2), offsetBottom/2);
    var emark2: HTMLElement | null = document.getElementById(String(id + 2));
    if (!emark2) {
        document.body.appendChild(mark2);   
        emark2 = document.getElementById(String(id + 2));
        mark2.addEventListener('keydown', function (e) {
            if (e.key === 'Enter') {
                if (a.magnetPosition) {
                    a.end = (a.magnetPosition as Point).clone();


                }
                else {
                    a.end = mouse.clone();
                }
                let inputValue1 = parseFloat(inputField1.value);
                let inputValue2 = parseFloat(inputField2.value);
                a.rectangle.width = inputValue1*a.zlc;
                a.rectangle.height = inputValue2*a.zlc;
                
                a.rectangle.p2 = new Point(a.rectangle.p1.x + a.rectangle.width, a.rectangle.p1.y);
                a.rectangle.p3 = new Point(a.rectangle.p1.x + a.rectangle.width, a.rectangle.p1.y + a.rectangle.height);
                a.rectangle.p4 = new Point(a.rectangle.p1.x, a.rectangle.p1.y + a.rectangle.height);
    
                a.rectangle.updateCenter();

                let shape = a.rectangle.getClone();
                shape.updatePoints();
    
                addShapes(shape);
    
    
                a.clickRectangleStart = null;
                a.isMouseDown = false;
                updateAndDrawShapes();
                clearTooltipAll();
    
            } 
            else if (e.altKey) {
                let inputValue2 = parseFloat(inputField2.value);
                rectHeight = inputValue2 * a.zlc;
                
           }
        });

        
    }

    var newTop = parseFloat(mark1.style.top.split('px')[0]) - mark1.clientHeight * 2 -10;
    mark1.style.top = newTop + 'px';
    mark2.style.top = (newTop + offset)+ 'px';
    
    
    let em1 = emark1?.firstChild as HTMLInputElement | null;
    let em2 = emark2?.firstChild as HTMLInputElement | null;
    if (em1) {
        em1.value = String(width);
        em1.focus();
        em1.select();
    }
    if (em2) {
        em2.value = String(height);
    }


    emark2?.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
            

        }
    });

}
/**
 * Функция добавляет поля для ввода радиуса для круга
 */
function addTooltipRadius(id: string, selectBoundary: SelectBoundary, radius: number, anchorFunction: (boundary: SelectBoundary) => Point) {
    var anchor = anchorFunction(selectBoundary);
    var offsetBottom = 25;
    var { tooltip, inputField } = createTooltipWithInput(radius, id, offsetBottom);
    var existingTooltip = document.querySelector(`.${ttcname}`);
    if (!existingTooltip) {
        inputField.value = String(radius);
        inputField.focus();
        inputField.select();
        document.body.appendChild(tooltip);
        inputField.addEventListener("keydown", function (e) {
            if (e.key === 'Enter') {
                let inputValue = parseFloat(inputField.value);
                a.circle.radius = inputValue * a.zlc;
                a.circle.setSelectBoundary();
                addShapes(a.circle.getClone());
                updateAndDrawShapes();
                a.clickCircleStart = null;
                a.isMouseDown = false;
                clearTooltipAll();
            }
        });
    }
    else {
        let input = existingTooltip.firstChild as HTMLInputElement;
        input.value = String(radius);
        input.focus();
        input.select();
    }
}
function createTooltipWithInput(length: number, id: string, offsetBottom: number):{tooltip:HTMLElement, inputField:HTMLInputElement} {
    var tooltip:HTMLElement = document.createElement("div");
    var inputField:HTMLInputElement = document.createElement("input");
    
    inputField.setAttribute("type", "number");
    inputField.setAttribute("value", String(length));
    inputField.setAttribute("id", id);
    inputField.classList.add("shape-tooltip-input");

    tooltip.classList.add(ttcname);
    tooltip.setAttribute("id", id);

    // var anchorX = anchor.x
    // var anchorY = anchor.y
    
    
    var offsetLeft = window.innerWidth /2 - 100;
    var offsetBottom = offsetBottom;

    

    var anchorX = offsetLeft;
    var anchorY = offsetBottom;
    tooltip.style.left = anchorX + "px";
    tooltip.style.bottom = anchorY + "px";
    inputField.value = String(length);
    tooltip.appendChild(inputField);
    return { tooltip, inputField };
}

/**
 * Функция удаления подсказки. У объекта одновременно может отображаться только одна подсказка
 */
function removeTooltip(id: string) {
    let tooltip = document.getElementById(id);
    if (tooltip) {
        document.body.removeChild(tooltip);
    }
}

/**
 * Функция удаляет все подсказки shape-tooltip из документа
 */
function clearTooltipAll() {
    let tooltips = document.querySelectorAll(`.${ttcname}`);
    for (let i = 0; i < tooltips.length; i++) {
        document.body.removeChild(tooltips[i]);
    }
}

/**
 * Функция добавляет подсказку без поля ввода
 */
function createInfoTooltip(message: string) {
    var tooltip = document.createElement('div');
    var anchor = new Point(OFFSET_LEFT, OFFSET_BOTTOM);
    tooltip.classList.add(ttcname);
    tooltip.innerHTML = message;
    tooltip.style.left = anchor.x+'px';
    tooltip.style.bottom = anchor.y+'px';
    document.body.appendChild(tooltip);
}



export { addTooltipInfo, clearTooltipAll, addTooltipLength, addTooltipWidthAndHeight, addTooltipRadius, createTooltipWithInput, createInfoTooltip };